import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams, Translation } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CookieService } from '@services';

@Injectable({ providedIn: 'root' })
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  constructor(private cookieService: CookieService) {}

  handle(params: MissingTranslationHandlerParams): Translation | Observable<Translation> {
    const locale = this.cookieService.getI18NLocale() || 'en-us';
    const brand = this.cookieService.getI18NBrand() || 'calibrant';
    params.translateService.setDefaultLang(`${locale}.${brand.toUpperCase()}`);
    params.translateService.use(`${locale}.${brand.toUpperCase()}`);
    return undefined;
  }
}
